export const Flag = Object.freeze({
  ACTIVE: 1,
  DEACTIVATE: 0,
  NOT_DELETED: 0,
})

export default { Flag }
